import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import TranslationProvider, { getTranslation } from '../../../providers/TranslationProvider';
import ProfilePhoto from '../../ProfilePhoto';

import './PhotoInput.scss';

const PhotoInput = ({
  url,
  onFileChange,
  isGda,
  isMobile,
  size,
  canClickPhoto,
  buttonText,
  buttonKey,
}) => {
  const fileInputRef = useRef(null);

  const handleKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      fileInputRef.current?.click();
    }
  };

  const openFileInput = (e) => {
    e.stopPropagation();
    if (e.type === 'keydown') {
      return handleKeyDown(e);
    }
    return fileInputRef.current?.click();
  };

  return (
    <div className={cx('PhotoInput', { 'PhotoInput--isMobile': isMobile })}>
      <input
        onClick={(e) => e.stopPropagation()}
        id="PhotoInput__file-input"
        type="file"
        accept="image/*"
        onChange={() => {
          const file = fileInputRef.current.files[0] || null;
          onFileChange(file);
        }}
        ref={fileInputRef}
        data-testid="PhotoInput__file-input"
      />
      <ProfilePhoto
        onClick={canClickPhoto ? (e) => openFileInput(e) : undefined}
        url={url}
        size={size}
        isGda={isGda}
      />
      {!isMobile && (
        <button
          className={cx('PhotoInput__label', { 'PhotoInput__label--gda': isGda })}
          onClick={openFileInput}
          onKeyDown={handleKeyDown}
          type="button"
          data-test-id="photo_input-button-change"
          aria-label={getTranslation({
            translationKey: 'profile_photo_change_aria_label',
            fallback: 'Change Profile Picture',
          })}
        >
          <TranslationProvider translationKey={buttonKey}>
            {buttonText}
          </TranslationProvider>
        </button>
      )}
    </div>
  );
};

PhotoInput.propTypes = {
  url: PropTypes.string,
  onFileChange: PropTypes.func.isRequired,
  isGda: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired,
  size: PropTypes.string,
  canClickPhoto: PropTypes.bool,
  buttonText: PropTypes.string,
  buttonKey: PropTypes.string,
};

PhotoInput.defaultProps = {
  url: undefined,
  isGda: false,
  size: '100',
  canClickPhoto: false,
  buttonText: 'Change',
  buttonKey: 'profile_photo_change',
};

PhotoInput.displayName = 'PhotoInput';
export default PhotoInput;
